(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ba-fb1-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
    $('.RTHE .slick-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        asNavFor: '.RTHE .slick-slider-sync'
    });
    $('.RTHE .slick-slider-images').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.RTHE .slick-slider-sync',
        responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
    $(".RTHE .scroll-arrow").click(function() {
        $('.slick-slider-images .slick-next, .slick-slider .slick-next').click();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-width-slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".full-width", {
      slidesPerView: 6,
      loop: true,
      autoplay: {
         delay: 750,
       },
      breakpoints: {
      480: {
        slidesPerView: 3,
        loop: true,
        autoplay: {
           delay: 750,
         },
      },
      640: {
        slidesPerView: 5,
        loop: true,
        autoplay: {
           delay: 750,
         },
      },
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-blends"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $(".newBlends__footer").click(function() {
        // Find the parent card of the clicked footer
        var $card = $(this).closest('.newBlends__slide');

        // Toggle the class for the specific card
        $card.toggleClass('more__info');
    });

     // Remove class when clicking on the close icon
    $(".newBlends__closeIcon").click(function(e) {
        e.stopPropagation();  // Prevent the click from propagating to the footer
        var $card = $(this).closest('.newBlends__slide');
        $card.removeClass('more__info');
    });
  });

var swiper = null; // Initialize swiper as null

function initSwiper() {
  if ($(window).width() < 1024) {
    swiper = new Swiper(".newBlends__carousal", {
      speed: 400,
      slidesPerView: 1.2,
      spaceBetween: 12,
      threshold: 2,
      loop: true,
      autoplay: {
         delay: 3000,
       },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        767: {
          slidesPerView: 1.9,
          loop: true,
          autoplay: {
             delay: 3000,
           },
        },
      },
    });
  } else if (swiper !== null) {
    // If swiper is initialized and window width is >= 1024, destroy it
    swiper.destroy();
    swiper = null;
  }
}

// Call the initSwiper function on window load and resize
$(document).ready(function () {
  initSwiper(); // Initialize on page load
});

$(window).resize(function () {
  initSwiper(); // Reinitialize or destroy on window resize
});

  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalized-baseline"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  $(".baseline__header").click(function () {
    $(this).toggleClass("open");
    $(".baseline__card").toggleClass("active");
    $(".baseline__percentage .per-block").css("max-width", "0%");
    setTimeout(function(){
      $(".baseline__percentage").each(function(){
        for (let index = 0; index <= $(this).find(".per-block").attr("per-width"); index++) {
          $(this).find(".per-block").css("max-width", index+"%");
        }
      })
    }, 1000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalized-insights"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function () {
  $(".insights__header").click(function () {
    $(this).toggleClass("open");
    $(".insights__card").toggleClass("active");
  });
});

  
document.getElementById("startCounter").addEventListener("click", function () {
  let count = document.querySelectorAll(".count");
  let arr = Array.from(count);

  arr.map(function (item) {
    let startnumber = 0;

    function counterup() {
      startnumber++;
      item.innerHTML = startnumber;

      if (startnumber == item.dataset.number) {
        clearInterval(stop);
        item.classList.add("target-reached");
      }
    }
    let stop = setInterval(counterup, 55);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trusted_by_experts"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper(".experts_slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      threshold:2,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 1.55,
          spaceBetween: 40,
        },
        1440: {
          slidesPerView: 1.6,
          spaceBetween: 40,
        },
      },
    });

  } catch(e) { console.error(e); }
})();
})();
